import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m.824 11.023 4.133-.849A4.78 4.78 0 0 0 8.38 7.07L10.513.774l3 .047-2.43 7.165a7.61 7.61 0 0 1-5.068 4.854zm22.99 3.877-4.076.837a4.78 4.78 0 0 0-3.432 3.099l-2.166 6.39-2.855-.044-.13-.041 2.448-7.221a7.61 7.61 0 0 1 5.074-4.855zm-6.26-3.124 6.846 2.516V11.25l-5.866-2.154c-1.404-.52-2.372-1.687-3.05-3.665l-1.282-4.388-1.572 4.78.144.49c.958 2.85 2.527 4.635 4.78 5.463M.4 11.663l6.74 2.472c2.344.862 4.048 2.82 4.797 5.516l.137.436-1.53 4.643-1.352-4.294c-.495-1.799-1.573-3.077-3.037-3.616L.4 14.705z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }